// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CONVERT_ASM_TO_CSV_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CONVERT_ASM_TO_CSV,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input files': {
        systemName: 'Input files',
        displayName: 'Input files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output files': {
        systemName: 'Output files',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      transformType: {
        kind: 'enum',
        required: true,
        choices: [
          'Allotrope',
          'Analyte',
          'Compensation',
          'Datacube',
          'Fractions',
          'Group',
          'Injections',
          'Log',
          'Measurement',
          'Measurement Separate Unit Column',
          'Original',
          'Peaks',
          'Processed',
          'Population',
          'Region',
          'Report Point',
          'Report',
          'Sample',
          'Sample Separate Unit Column',
          'Statistics',
          'Timeseries',
          'Well'
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
